module.exports = __webpack_public_path__ + "static/scale-model-of-albuquerque-new-mexico-5f4c6ed830cf72737627146ecae57c60.png";